const initialState = {
    userDataPending: false,
    userDataFetched: false,

    userStatsPending: false,
    userStatsFetched: false,

    sendInvitationPending: false,

    userData: {
        id: null,
        email: "",
        fullname: "",
        referralCode: "xxxxxxxxxxxxx"
    },

    userStats: {
        minutesMeditating: 0,
        meditatedAt: [],
        completedMeditationsCount: 0
    },
};

const UserReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_USER_DATA_PENDING':
        case 'UPDATE_USER_PENDING':
            return Object.assign({}, state, {
                userDataPending: true,
                userDataFetched: false,
            });

        case 'GET_USER_DATA_FULFILLED':
        case 'UPDATE_USER_FULFILLED':

            return Object.assign({}, state, {
                userDataPending: false,
                userDataFetched: true,
                userData: action.payload
            });

        case 'GET_USER_DATA_REJECTED':
        case 'UPDATE_USER_REJECTED':
            return Object.assign({}, state, {
                userDataPending: false,
                userDataFetched: false,
            });

        case 'GET_USER_STATS_PENDING':
            return Object.assign({}, state, {
                userStatsPending: true,
                userStatsFetched: false,
            });

        case 'GET_USER_STATS_FULFILLED':
            return Object.assign({}, state, {
                userStatsPending: false,
                userStatsFetched: true,
                userStats: action.payload
            });

        case 'GET_USER_STATS_REJECTED':
            return Object.assign({}, state, {
                userStatsPending: false,
                userStatsFetched: false,
            });

        case 'SEND_INVITATION_PENDING':
            return Object.assign({}, state, {sendInvitationPending: true});

        case 'SEND_INVITATION_FULFILLED':
        case 'SEND_INVITATION_REJECTED':
            return Object.assign({}, state, {sendInvitationPending: false});

        default:
            return state;
    }
};

export default UserReducer;


// WEBPACK FOOTER //
// ./src/reducers/User.js